import React from "react";
import { SearchContainer } from "../../../../common/styled/project";

const SearchForm = ({ isGrp, searched, setSearched, handleSearch }) => {
  return (
    <SearchContainer className="search">
      <input
        type="text"
        value={searched}
        onChange={(e) => setSearched(e.target.value)}
        onKeyDown={(e) => handleEnterKey(e, handleSearch)}
        placeholder={isGrp ? "닉네임을 입력해주세요." : "이름을 입력해주세요."}
      />
      <button onClick={handleSearch}>검색</button>
    </SearchContainer>
  );
};

export default SearchForm;
